import { render, staticRenderFns } from "./ModalBinderForm.vue?vue&type=template&id=7396d157&"
import script from "./ModalBinderForm.vue?vue&type=script&lang=js&"
export * from "./ModalBinderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports